import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportAccumulatedDiscountFilters, getReportAccumulatedDiscountAction } from "redux/actions/Reports/reportAccumulatedDiscount/reportAccumulatedDiscountActions";
import { useSearch } from "hooks/useSearch";

export const ReportAccumulatedDiscountView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportAccumulatedDiscount);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportAccumulatedDiscountAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Descuentos Acumulados" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportAccumulatedDiscount"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportAccumulatedDiscountFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingAccumulatedDiscount}
      />
      {isLoadingComp?.loadingAccumulatedDiscount && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
